<template>
    <div class="item"
        :style="styleItem">
        <div class="item-inner"
            :class="{
                'item-centered' : isCenterd,
                'item-centered-sides': indexDiff === 1,
                'item-centered-sides-2': indexDiff === 2,
                'item-centered-sides-3': indexDiff === 3,
            }"
            @click="() => {
                indexDiff - 1 < (showCount / 2) && onItemClick(item)
            }"
            :style="itemInnerStyle">
            <div class="mask-carousel"></div>
            <div class="item-label">
                {{item.text}}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        styleItem: {},
        index: {},
        item: {},
        indexDiff: {},
        itemInnerStyle: {},
        isCenterd: {},
        onItemClick: {},
        showCount: {}
    }
}
</script>

